import circleSrc from '../../assets/icons/circle0.svg';

const getData = (isMobile = false) => (isMobile ? ({
    intro: [
        {
            x: -10,
            y: 40,
            w: 122,
            r: 180,
            o: 0.48
        },
        {
            x: 250,
            y: 440,
            w: 186,
            r: 120,
            o: 0.48
        },
        {
            x: 260,
            y: 870,
            w: 120,
            r: 0,
            o: 0.64
        }
    ],
    facts: [
        {
            x: 100,
            y: 1020,
            w: 720,
            r: 0,
            o: 0.13
        }
    ],
    fans: [
        {
            x: -420,
            y: 2000,
            w: 680,
            r: -60,
            o: 0.13
        }
    ],
    oscars: [
        {
            x: -400,
            y: 3000,
            w: 800,
            r: 95,
            o: 0.29
        }
    ]
}) : ({
    intro: [
        {
            x: 188,
            y: 180,
            w: 503,
            r: 180,
            o: 0.48
        },
        {
            x: 750,
            y: 1000,
            w: 262,
            r: 120,
            o: 0.48
        },
        {
            x: -220,
            y: 1700,
            w: 510,
            r: 0,
            o: 1
        }
    ],
    facts: [
        {
            x: -630,
            y: 900,
            w: 1110,
            r: 0,
            o: 0.17
        },
        {
            x: 1100,
            y: 400,
            w: 600,
            r: 0,
            o: 0.13
        }
    ],
    events: [
        {
            x: 980,
            y: 380,
            w: 770,
            r: -20,
            o: 0.48
        },
        {
            x: -780,
            y: 1530,
            w: 1410,
            r: 200,
            o: 0.24
        }
    ],
    fans: [
        {
            x: 1200,
            y: 320,
            w: 820,
            r: -20,
            o: 0.13
        },
        {
            x: -540,
            y: 1000,
            w: 1120,
            r: -40,
            o: 0.17
        },
        {
            x: 1300,
            y: 2500,
            w: 830,
            r: -75,
            o: 0.27
        }
    ],
    oscars: [
        {
            x: 1100,
            y: 650,
            w: 1356,
            r: -35,
            o: 0.17
        },
        {
            x: -650,
            y: 3000,
            w: 1152,
            r: 95,
            o: 0.29
        }
    ]
}));

const toPercents = (px, dimension) => `${(px / dimension) * 100}%`;

const calcShift = (width, isMobile) => {
    const baseShiftSize = isMobile ? 250 : 550;

    return width / baseShiftSize;
};

const createCircle = (
    {
        x, y, w, r, o
    },
    {
        width, height
    },
    isMobile = false
) => {
    const wrap = document.createElement('div');
    const img = document.createElement('img');

    img.src = circleSrc;
    img.alt = 'circle shape';
    img.setAttribute('aria-hidden', true);

    wrap.style.width = toPercents(w, width);
    wrap.style.left = toPercents(x, width);
    wrap.style.top = toPercents(y, height);
    wrap.style.setProperty('--circle-shift', calcShift(w, isMobile));
    img.style.transform = `rotate(${r}deg)`;
    img.style.opacity = o;

    wrap.classList.add('circle-wrap');
    img.classList.add('circle-img');

    wrap.appendChild(img);

    return wrap;
};

export const circlesFactory = (section = document.querySelector('section.section'), isMobile = false) => {
    const data = getData(isMobile)[section.id] || null;

    if (Array.isArray(data) && data.length > 0) {
        const cirlces = data.map((params) => createCircle(params, section.getBoundingClientRect(), isMobile));

        cirlces.forEach((cirlceNode) => section.appendChild(cirlceNode));

        return cirlces;
    }

    return [];
};
